import type { Patient } from "~/api/patients";
import {
  mapInsuranceDetails,
  mapPreferredOffice,
  mapReferral,
} from "./patientDataMapper";

/**
 * Transforms frontend Patient store data into the payload shape
 * expected by the PATCH /backoffice/patients/drafts endpoint.
 * Uses the same enum-to-string mapping as the patient creation flow.
 */
export const patientToSyncPayload = (
  patient: Patient,
): Record<string, unknown> => {
  const payload: Record<string, unknown> = {};

  if (patient.firstName) payload.firstName = patient.firstName;
  if (patient.lastName) payload.lastName = patient.lastName;
  if (patient.email) payload.email = patient.email;
  if (patient.phone) payload.phone = patient.phone;
  if (patient.state) payload.state = patient.state;
  if (patient.conditions?.length) payload.conditions = patient.conditions;
  if (patient.referral) payload.referral = mapReferral(patient.referral);
  if (patient.otherReferral) payload.otherReferral = patient.otherReferral;
  if (patient.referringPracticeId != null)
    payload.referringPracticeId = patient.referringPracticeId;
  if (patient.referringDoctorId != null)
    payload.referringDoctorId = patient.referringDoctorId;
  if (patient.referringDoctorName)
    payload.referringDoctorName = patient.referringDoctorName;
  if (patient.extraInformation)
    payload.extraInformation = patient.extraInformation;

  payload.preferredOfficeVisit = mapPreferredOffice(patient);

  const primaryInsurance = mapInsuranceDetails(patient.primaryInsurance);
  if (primaryInsurance) payload.primaryInsurance = primaryInsurance;

  const secondaryInsurance = mapInsuranceDetails(patient.secondaryInsurance);
  if (secondaryInsurance) payload.secondaryInsurance = secondaryInsurance;

  return payload;
};
